<template>
  <div class="md-layout">
    <div class="md-layout md-alignment-top-right">
      <md-button id="referralRewardBtn" class="md-info" @click="claimReferralReward">Claim Referral Reward</md-button>
      <md-button id="adjustBalanceBtn" class="md-info" @click="showBalancePopup = true">Adjust Balance</md-button>
    </div>

    <user-info-card class="md-layout-item md-size-100" :user="user" :wallet="wallet" @removePhoneNumber="removePhoneNumber" @addPhoneNumber="showPhoneNumberPopup = true" />
    <balance-logs-table :key="userInfoCardKey" class="md-layout-item md-size-100" :walletID="wallet.id" />

    <md-dialog :md-active.sync="showBalancePopup" :md-click-outside-to-close="false">
      <md-dialog-title> Adjust How Much? </md-dialog-title>
      <div style="padding: 8px;">
        <md-field class="md-layout-item">
            <label>Type</label>
            <md-select v-model="adjustType">
                <md-option value="refund">Refund</md-option>
                <md-option value="promo">Promo</md-option>
                <md-option value="admin">Admin Adjust</md-option>
            </md-select>
        </md-field>
        <md-field class="md-layout-item">
          <label>Amount</label>
          <span class="md-prefix">$</span>
          <md-input v-model.number="amountToAdd" type="number" min="0" step="0.01" />
        </md-field>
      </div>
      <md-dialog-actions>
        <md-button class="md-black" :disabled="isSaving" @click="closeBalancePopup">Close</md-button>
        <md-button class="md-primary" :disabled="isSaving" @click="adjustBalance">Save</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="showPhoneNumberPopup" :md-click-outside-to-close="false">
      <md-dialog-title> Add Phone Number </md-dialog-title>
      <div style="padding: 8px;">
        <label class="text-gray">
          Example: 1 222 333 4444
        </label>
        <VuePhoneNumberInput
          v-model="newPhoneNumber"
          default-country-code="US"
          :no-country-selector="true"
          :no-validator-state="true"
          :no-example="true"
          :border-radius="2"
          size="lg"
        />
      </div>
      <md-dialog-actions>
        <md-button class="md-black" :disabled="isSaving" @click="closePhoneNumberPopup">Close</md-button>
        <md-button class="md-primary" :disabled="isSaving || !isNewPhoneNumberValid" @click="savePhoneNumber">Save</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-snackbar md-position="center" :md-duration="1500" :md-active.sync="barMessage" md-persistent>
      <span> {{ barMessage }} </span>
    </md-snackbar>
  </div>
</template>

<script>
import UserInfoCard from "@/components/Cards/User/UserInfoCard"
import BalanceLogsTable from "@/components/Tables/User/BalanceLog"
import Swal from "sweetalert2";
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

export default {
  components: {
    UserInfoCard,
    BalanceLogsTable,
    VuePhoneNumberInput
  },
  created() {
    this.getUserDetail()
  },
  data() {
    return {
      user: {},
      newPhoneNumber: null,
      showPhoneNumberPopup: false,
      // https://en.wikipedia.org/wiki/North_American_Numbering_Plan#Modern_plan
      phoneRegex: /^1[2-9][0-8][0-9][2-9](?!11)[0-9][0-9][0-9]{4}$/,
      wallet: {},
      userInfoCardKey: 0,
      showBalancePopup: false,
      adjustType: 'admin',
      amountToAdd: 0,
      isSaving: false,
      barMessage: null
    }
  },
  computed: {
    isNewPhoneNumberValid() {
      return this.phoneRegex.exec(this.cleanPhone(this.newPhoneNumber))
    }
  },
  methods: {
    getUserDetail() {
      this.$http.secured.get(`/v2/admins/app_users/${this.$route.params.id}`)
        .then(response => {
          this.user = response.data.user
          this.wallet = response.data.wallet
          this.userInfoCardKey = response.data.wallet.balance
        })
        .catch(error => alert(error))
    },
    createBalanceLog() {
      this.$http.secured.post(`/v1/balance_logs`, { wallet_id: this.wallet.id, amount: this.amountToAdd, type: this.adjustType })
        .then(response => {
          this.wallet.balance = response.data.logs.ending_balance
          this.userInfoCardKey = this.wallet.balance
          this.barMessage = "Balance Adjust Success"
          this.closeBalancePopup()
        })
        .catch(error => alert(error))
        .finally(this.isSaving = false)
    },
    adjustBalance() {
      this.isSaving = true
      this.createBalanceLog()
    },
    closeBalancePopup() {
      this.showBalancePopup = false
      this.amountToAdd = 0
      this.adjustType = 'admin'
    },
    claimReferralReward() {
      const url = `/v2/admins/app_users/${this.user.id}/claimed_referral_rewards`
      this.$http.secured.post(url)
      .then(response => {
        const reward = response.data.reward
        Swal.fire({
          title: "Claimed!",
          text: `Claimed: ${reward.title} (type: ${reward.reward_type}, value: ${reward.value})`,
          type: "success",
          confirmButtonClass: "md-button md-success",
          buttonsStyling: false
        })
      })
      .catch(error => {
        const meta = error.response.data.meta
        alert((meta && meta.message) || error)
      })
    },
    savePhoneNumber() {
      this.isSaving = true
      const url = `/v2/admins/app_users/${this.user.id}/phone_number`
      const { cleanPhone, newPhoneNumber } = this
      this.$http.secured.post(url, {phone_number: cleanPhone(newPhoneNumber)})
      .then(response => {
        this.user.phone_number = response.data.phone_number
        this.barMessage = "Phone Number Updated"
        this.closePhoneNumberPopup()
      })
      .catch(error => {
        const meta = error.response.data.meta
        alert((meta && meta.message) || error)
      })
      .finally(this.isSaving = false)
    },
    closePhoneNumberPopup() {
      this.showPhoneNumberPopup = false
      this.newPhoneNumber = null
    },
    cleanPhone(phoneNumber) {
      return ('' + phoneNumber).replace(/\D/g, '')
    },
    removePhoneNumber() {
      Swal.fire({
        title: "Are you sure you want to remove this phone number?",
        text: "You won't be able to revert this",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Yes, remove it",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          const url = `/v2/admins/app_users/${this.user.id}/phone_number`
          this.$http.secured.delete(url)
          .then(response => {
            this.user.phone_number = null
            Swal.fire({
              title: "Removed!",
              text: "Phone number has been removed.",
              type: "success",
              confirmButtonClass: "md-button md-success",
              buttonsStyling: false
            })
          })
          .catch(error => alert(error))
        }
      })
    }
  }
}
</script>

<style lang=scss>
#referralRewardBtn, #adjustBalanceBtn {
  margin-right: 15px;
}
</style>
